<template>
  <!-- Courses Admin Start -->
  <div class="section overflow-hidden position-relative  min-height" id="wrapper">
    <!-- Page Content Wrapper Start -->
    <div class="page-content-wrapper padding-top-0 padding-left-0">
      <div class="container-fluid custom-container">

        <div v-if='!test_started'>
          <TestStartScreen v-if='query' :test='query.test_type'/>
          <button class="btn btn-primary btn-hover-dark" @click='start_test'>Start Test</button>
        </div>

        <!-- Graph Top Start -->
        <div v-else class="graph">
          <div v-if="test_type == 'mock'" class="student-box float-right">
            <h5 class="title">Time Remaining</h5>
            <div class="count">{{ formattedTime }}</div>
          </div>

          <!-- Admin Courses Tab Start -->
          <div class="admin-courses-tab">
            <div class="courses-tab-wrapper">
              <ul class="nav">
                <li v-for="(question, index) in questions" :key="index">
                  <button
                  :class="getButtonClass(index)"
                  @click="selectTab(index)">
                  {{ index + 1 }}
                </button>
                </li>
              </ul>
            </div>
          </div>
          <!-- Admin Courses Tab End -->

          <!-- Admin Courses Tab Content Start -->
          <div class="admin-courses-tab-content" v-if='currentQuestion'>
            <div class="tab-content">
              <div class="tab-pane fade show active" id="tab1">
                <div class="padding-top-50">
                  <p class="question">Question: {{ currentQuestion.question }}</p>

                  <img v-if="currentQuestion.question_image" :src="get_img(currentQuestion._id)" alt="Question Image" class="question-img mb-2" width="500" />

                  <p class="question">Select any 1 from the below options:</p>

                  <!-- Answer List Start -->
                  <div class="max-width-700">
                    <div 
                      v-for="(option, index) in currentQuestion?.options" 
                      :key="index" 
                      class="single-answer boder-color-silver"
                      @click="selectAnswer(index)" 
                      :class="{ active: userAnswers[currentIndex] === index }"
                    >
                      <h6 class="margin-bottom-0">{{index + 1}}. {{ option }}</h6>
                    </div>
                  </div>
                  <!-- Answer List End -->
                </div>
              </div>
            </div>
          </div>
          <!-- Admin Courses Tab Content End -->

          <div class="message-form">
            <div class="message-input">
              <div class="message-btn button-width">
                <button class="btn btn-secondary btn-hover-primary" 
                  :class="{ 'color-red': isFlagged(currentIndex) }"
                  @click="flag">
                  <i class="icofont-flag"></i> {{ isFlagged(currentIndex) ? 'Unflag' : 'Flag' }} Question
                </button>
                <button class="btn btn-secondary btn-hover-dark" @click="checkAnswer" v-if="test_type=='practice'">Check Answer</button>
                <button class="btn btn-primary btn-hover-dark" @click="previous" :disabled="currentIndex === 0">
                  <i class="icofont-ui-previous"></i> Previous Question
                </button>
                <button class="btn btn-primary btn-hover-dark" @click="next" :disabled="currentIndex === questions.length - 1">
                  Next Question<i class="icofont-ui-next"></i>
                </button>
                <button class="btn btn-success btn-hover-dark" @click="openConfirmSubmitModal">Submit Test</button>
              </div>
            </div>
          </div>

        </div>
        <!-- Graph Top End -->

        <!-- Reusable Modal Component -->
        <div class="modal" :class="{ 'd-block': showModal }" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ modalTitle }}</h5>
              </div>
              <div class="modal-body">
                <p>{{ modalMessage }}</p>
                
                <!-- Test Summary for Submit Confirmation -->
                <div v-if="modalType === 'confirm'" class="test-summary">
                  <h6 class="mb-3">Test Summary:</h6>
                  <div class="summary-stats">
                    <div class="summary-item">
                      <span class="summary-label">Total Questions:</span>
                      <span class="summary-value">{{ questions.length }}</span>
                    </div>
                    <div class="summary-item answered">
                      <span class="summary-label">Answered:</span>
                      <span class="summary-value">{{ getAnsweredCount() }}</span>
                    </div>
                    <div class="summary-item unanswered">
                      <span class="summary-label">Unanswered:</span>
                      <span class="summary-value">{{ getUnansweredCount() }}</span>
                    </div>
                    <div class="summary-item flagged">
                      <span class="summary-label">Flagged:</span>
                      <span class="summary-value">{{ getFlaggedCount() }}</span>
                    </div>
                  </div>
                </div>

                <!-- Test Result Display -->
                <div v-if="modalType === 'testResult' && testResult">
                  <p>Correct Answers: {{ testResult.correctAnswers }} / {{ testResult.totalQuestions }}</p>
                  <p>Score: {{ Math.round((testResult.correctAnswers / testResult.totalQuestions) * 100) }}%</p>
                  <p>Time Taken: {{ formatTimeTaken(testResult.timeTaken) }}</p>
                </div>
              </div>
              <div class="modal-footer">
                <button v-if="modalType === 'confirm'" type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
                <button v-if="modalType === 'confirm'" type="button" class="btn btn-primary" @click="confirmModal">Confirm</button>
                <button v-if="modalType === 'alert'" type="button" class="btn btn-primary" @click="closeModal">OK</button>
                <button v-if="modalType === 'testResult'" type="button" class="btn btn-primary" @click="goToDashboard">Return to Dashboard</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End Reusable Modal Component -->

      </div>
    </div>
  </div>
  <!-- Page Content Wrapper End -->
</template>

<script>
import TestStartScreen from '@/components/Dashboard/User/TestStartScreen.vue';
import { startSession, getSessionDetail, saveAns, submit_test } from '@/services/testService';
import { AppConfig } from '@/constants';
// import axios from 'axios'; // Make sure axios is imported

export default {
  name: 'MockTest',
  components: { TestStartScreen },
  data() {
    return {
      query: null,
      test_started: false,
      currentIndex: 0,
      timeRemaining: null,
      totalDuration: 0,
      timer: null,
      userAnswers: [],
      flaggedQuestions: [],
      activeTab: 0,
      questions: [],
      sessionId: null,
      testCompleted: false,
      testResult: null,
      isPracticeMode: false,
      test_type: null,
      // Modal related data
      showModal: false,
      modalType: '', // 'alert', 'confirm', 'testResult'
      modalTitle: '',
      modalMessage: '',
      confirmCallback: null
    };
  },
  computed: {
    formattedTime() {
      let minutes = Math.floor(this.timeRemaining / 60);
      let seconds = this.timeRemaining % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
    currentQuestion() {
      return this.questions.length > 0 ? this.questions[this.currentIndex] : null;
    }
  },
  methods: {
    // Modal methods
    showAlertModal(title, message) {
      this.modalType = 'alert';
      this.modalTitle = title;
      this.modalMessage = message;
      this.showModal = true;
    },
    
    showConfirmModal(title, message, callback) {
      this.modalType = 'confirm';
      this.modalTitle = title;
      this.modalMessage = message;
      this.confirmCallback = callback;
      this.showModal = true;
    },
    
    showTestResultModal() {
      this.modalType = 'testResult';
      this.modalTitle = 'Test Completed';
      this.modalMessage = '';
      this.showModal = true;
    },

    getButtonClass(index) {
      if (this.isFlagged(index)) {
        return 'paginationred';
      } else if (this.activeTab === index) {
        return 'active';
      } else if (this.userAnswers[index] !== undefined) {
        return 'paginationgreen';
      }
      return '';
    },
    
    closeModal() {
      this.showModal = false;
    },
    
    confirmModal() {
      this.showModal = false;
      if (this.confirmCallback) {
        this.confirmCallback();
      }
    },
    
    openConfirmSubmitModal() {
      this.showConfirmModal('Confirm Submission', 'Are you sure you want to submit the test?', () => {
        this.submitTest(false);
      });
    },

    // Summary calculation methods
    getAnsweredCount() {
      return this.userAnswers.filter(answer => answer !== undefined).length;
    },

    getUnansweredCount() {
      return this.questions.length - this.getAnsweredCount();
    },

    getFlaggedCount() {
      return this.flaggedQuestions.length;
    },

    // ✅ Get question image
    get_img(id) {
      return AppConfig.API_BASE_URL + `/test/get_question_image/${id}`;
    },

    // ✅ Start the test and initialize session
    async start_test() {
      try {
        if (this.sessionId) {
          // Resume existing session
          await this.getSessionDetails();
        } else {
          // Start new session
          const response = await startSession({
            user_id: this.query.user_id,
            test_type_id: this.query.test_type,
            subscription_id: this.query.subscription_id
          });
          
          this.sessionId = response.data.sessionId;
          this.test_type = response.data.test_type;
          if(this.test_type == 'mock'){
            this.timeRemaining = response.data.duration - response.data.elapsedTime;
            this.totalDuration = response.data.duration;
          }
          
          this.userAnswers = response.data.userAnswers;
          
          await this.getSessionDetails();
        }
        
        this.test_started = true;
        if(this.test_type == 'mock'){
          this.startTimer();
        }
        
        // Save session ID to localStorage for recovery after refresh
        localStorage.setItem('currentTestSessionId', this.sessionId);
      } catch (error) {
        if(error.response && error.response.data && error.response.data.message == 'Invalid attempt number'){
          this.showAlertModal('Error', 'You have exhausted all your mock attempts');
        } else {
          this.showAlertModal('Error', 'An error occurred while starting the test');
        }
        console.error('Error starting test:', error);
      }
    },

    // ✅ Get session details
    async getSessionDetails() {
      try {
        const response = await getSessionDetail(this.sessionId);
        
        this.questions = response.data.questions;
        console.log(this.questions);
        this.test_type = response.data.test_type;
        if(this.test_type == 'mock'){
          this.timeRemaining = response.data.duration - response.data.elapsedTime;
          if (this.timeRemaining < 0) this.timeRemaining = 0;
        }
        
        this.userAnswers = response.data.userAnswers;
        
        // If test is already completed, show results
        if (response.data.is_completed) {
          this.testCompleted = true;
          clearInterval(this.timer);
          this.showTestResultModal();
        }
      } catch (error) {

        if (error.response.data.message == "Refresh limit reached"){
          this.showAlertModal('Error', 'Refresh limit reached, your test will be auto submitted, please reach out to admin!');
          setTimeout(()=>{
            this.submitTest(true);
          },2000);
        }else if(error.response.data.message == "Refresh window expired"){
          this.showAlertModal('Error', 'Refresh window expired, your test will be auto submitted, please reach out to admin!');
          setTimeout(()=>{
            this.submitTest(true);
          },2000);
        }else{
          this.showAlertModal('Error', 'An error occurred while loading test details');
          console.error('Error getting session details:', error);
        }
        
      }
    },

    // ✅ Start timer
    startTimer() {
      clearInterval(this.timer); // Clear any existing timer
      
      this.timer = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
          
          // Save time remaining to localStorage every 5 seconds
          if (this.timeRemaining % 5 === 0) {
            localStorage.setItem('timeRemaining', this.timeRemaining);
          }
        } else {
          // Auto submit when time is up - fixed to properly use autoSubmit parameter
          this.showAlertModal('Time\'s Up!', 'Your time has expired. The test will be submitted automatically.');
          setTimeout(() => {
            this.closeModal();
            this.submitTest(true);
          }, 2000);
        }
      }, 1000);
    },

    // ✅ Save answer to server
    async saveAnswer(index, answer) {
      try {
        await saveAns(this.sessionId, {
          questionIndex: index,
          answer: answer
        });
      } catch (error) {
        this.showAlertModal('Error', 'Failed to save answer');
        console.error('Error saving answer:', error);
      }
    },

    // ✅ Move to the next question
    next() {
      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex++;
        this.activeTab = this.currentIndex;
      }
    },

    // ✅ Move to the previous question
    previous() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.activeTab = this.currentIndex;
      }
    },

    // ✅ Flag a question for review
    flag() {
      const index = this.flaggedQuestions.indexOf(this.currentIndex);
      if (index === -1) {
        this.flaggedQuestions.push(this.currentIndex);
      } else {
        this.flaggedQuestions.splice(index, 1);
      }
      
      // Save flagged questions to localStorage
      localStorage.setItem('flaggedQuestions', JSON.stringify(this.flaggedQuestions));
    },

    // ✅ Check if a question is flagged
    isFlagged(index) {
      return this.flaggedQuestions.includes(index);
    },

    // ✅ Check Answer (for practice mode)
    checkAnswer() {
      if (!this.isPracticeMode) return;

      const currentQ = this.currentQuestion;
      if (!currentQ) return;

      const userAnswer = this.userAnswers[this.currentIndex];

      if (userAnswer === undefined) {
        this.showAlertModal('Information', 'Please select an answer first.');
        return;
      }

      if (userAnswer === currentQ.ans) {
        this.showAlertModal('Correct!', 'That is the correct answer!');
      } else {
        console.log(currentQ);
        this.showAlertModal('Incorrect', `Wrong Answer! The correct answer is - ${currentQ.options[currentQ.ans]}`);
      }
    },

    // ✅ Select an answer
    selectAnswer(optionIndex) {
      this.userAnswers[this.currentIndex] = optionIndex;
      
      // Save answer to localStorage and server
      localStorage.setItem('userAnswers', JSON.stringify(this.userAnswers));
      this.saveAnswer(this.currentIndex, optionIndex);
    },

    // ✅ Select a specific tab/question
    selectTab(index) {
      this.activeTab = index;
      this.currentIndex = index;
    },

    // ✅ Submit the test
    async submitTest(autoSubmit = false) {
      try {
        // Stop the timer if in mock test mode
        if(this.test_type == 'mock'){
          clearInterval(this.timer);
        }
        
        console.log(this.sessionId, this.query.user_id);
        const response = await submit_test(this.sessionId, {
          userId: this.query.user_id
        });
        
        this.testCompleted = true;
        this.testResult = response.data;
        
        // Show different messages based on auto submission or manual submission
        if (autoSubmit) {
          this.modalTitle = 'Test Auto-Submitted';
          this.modalMessage = 'Your test was automatically submitted as time expired.';
        } else {
          this.modalTitle = 'Test Completed';
          this.modalMessage = 'Your test has been successfully submitted.';
        }
        
        // Show test results
        this.showTestResultModal();
        
        // Clear localStorage
        localStorage.removeItem('currentTestSessionId');
        localStorage.removeItem('timeRemaining');
        localStorage.removeItem('userAnswers');
        localStorage.removeItem('flaggedQuestions');
      } catch (error) {
        this.showAlertModal('Error', 'An error occurred while submitting the test');
        console.error('Error submitting test:', error);
      }
    },

    // ✅ Format time taken for results display
    formatTimeTaken(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}m ${remainingSeconds}s`;
    },

    // ✅ Return to dashboard
    goToDashboard() {
      this.$router.push('/dashboard/user/home');
    },

    // ✅ Load test data from localStorage on refresh
    loadSavedTestData() {
      const sessionId = localStorage.getItem('currentTestSessionId');
      if (sessionId) {
        this.sessionId = sessionId;
        if(this.test_type == 'mock'){
          this.timeRemaining = parseInt(localStorage.getItem('timeRemaining') || '0');  
        }
        
        this.userAnswers = JSON.parse(localStorage.getItem('userAnswers') || '[]');
        this.flaggedQuestions = JSON.parse(localStorage.getItem('flaggedQuestions') || '[]');
        
        // Resume test if there was an ongoing session
        if (this.sessionId) {
          this.start_test();
        }
      }
    }
  },
  mounted() {
    this.query = this.$route.params;
    this.isPracticeMode = this.query.test_type === 'practice';

    // Only "mock" resumes a previously in-progress session from
    // localStorage (needed so a page refresh mid-final-test doesn't lose
    // the timer/answers). Practice test has no timer and nothing forcing
    // the user to finish it, so if we resumed it the same way, opening
    // "Practice Test" again after walking away without submitting would
    // silently reload the exact same old session — same questions, same
    // shuffled order, every time. So practice always starts a brand new
    // session instead, and any leftover data from a past practice attempt
    // is cleared out here so it can never leak into the new one.
    if (this.query.test_type === 'mock') {
      this.loadSavedTestData();
    } else {
      localStorage.removeItem('currentTestSessionId');
      localStorage.removeItem('timeRemaining');
      localStorage.removeItem('userAnswers');
      localStorage.removeItem('flaggedQuestions');
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
}
</script>

<style scoped>
/* Modal styles */
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}
.d-block {
  display: block !important;
}

/* Test Summary Styles */
.test-summary {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.test-summary h6 {
  color: #333;
  font-weight: 600;
  margin-bottom: 15px;
}

.summary-stats {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  border-left: 4px solid #6c757d;
}

.summary-item.answered {
  border-left-color: #28a745;
}

.summary-item.unanswered {
  border-left-color: #dc3545;
}

.summary-item.flagged {
  border-left-color: #ffc107;
}

.summary-label {
  font-weight: 500;
  color: #495057;
}

.summary-value {
  font-weight: 700;
  font-size: 18px;
  color: #212529;
}
</style>